const conditionalList = (obj: any) => {
  const result: string[] = [];
  Object.keys(obj).forEach((key) => {
    if (obj[key]) result.push(key);
  });
  return result;
};

export default conditionalList;
